import { render, staticRenderFns } from "./talkCategory.vue?vue&type=template&id=14e88340&scoped=true&"
import script from "./talkCategory.vue?vue&type=script&lang=js&"
export * from "./talkCategory.vue?vue&type=script&lang=js&"
import style0 from "./talkCategory.vue?vue&type=style&index=0&id=14e88340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e88340",
  null
  
)

export default component.exports